/**
 * Сбрасывает форму и диспатчит события change для всех полей, у которых изменилось значение.
 * Поддерживает input (radio, checkbox, text).
 *
 * @param {Object} options
 * @param {string} options.exceptName - Название поля, которое следует исключить из сброса
 */
export const resetAndDispatchParams = ({ exceptName }) => {
    const form = document.getElementById("form-object-params");
    if (!(form instanceof HTMLFormElement)) return;

    const elements = Array.from(form.querySelectorAll("input"));
    const snapshot = buildSnapshot(elements);
    const exceptState = getExceptState(snapshot, exceptName);

    form.reset();

    restoreExceptField(form, exceptName, exceptState);
    dispatchChanges(form, snapshot, exceptName);
};

const buildSnapshot = (elements) => {
    const snapshot = new Map();

    elements.forEach((el) => {
        if (!el.name) return;

        if (!snapshot.has(el.name)) {
            snapshot.set(el.name, []);
        }

        snapshot.get(el.name).push({
            el,
            type: el.type,
            value: el.value,
            checked: el.checked,
        });
    });

    return snapshot;
};

const getExceptState = (snapshot, exceptName) => {
    if (!exceptName) return null;

    const group = snapshot.get(exceptName);
    if (!group) return null;

    const isRadio = group[0]?.type === "radio";
    const isCheckbox = group[0]?.type === "checkbox";

    if (isRadio) {
        const checked = group.find((i) => i.checked);
        return checked ? checked.value : null;
    }

    if (isCheckbox) {
        return group[0].checked;
    }

    return group[0].value;
};

const restoreExceptField = (form, exceptName, exceptState) => {
    if (!exceptName || exceptState === null || exceptState === undefined) return;

    const inputs = form.querySelectorAll(`[name="${exceptName}"]`);
    if (!inputs.length) return;

    const first = inputs[0];

    if (first.type === "radio") {
        inputs.forEach((input) => {
            input.checked = input.value === exceptState;
        });
        return;
    }

    if (first.type === "checkbox") {
        inputs.forEach((input) => {
            input.checked = !!exceptState;
        });
        return;
    }

    inputs.forEach((input) => {
        input.value = exceptState;
    });
};

const dispatchChanges = (form, snapshot, exceptName) => {
    const radioProcessed = new Set();

    snapshot.forEach((group, name) => {
        if (name === exceptName) return;

        const currentInputs = form.querySelectorAll(`[name="${name}"]`);

        group.forEach((prevItem, index) => {
            const current = currentInputs[index];
            if (!current) return;

            const isRadio = current.type === "radio";
            const isCheckbox = current.type === "checkbox";

            let changed = false;

            if (isRadio) {
                const prevChecked = prevItem.checked;
                const currChecked = current.checked;
                changed = prevChecked !== currChecked;
            } else if (isCheckbox) {
                changed = prevItem.checked !== current.checked;
            } else {
                changed = prevItem.value !== current.value;
            }

            if (!changed) return;

            if (isRadio) {
                if (radioProcessed.has(name)) return;

                const checked = group.find((i, iIndex) => {
                    const el = currentInputs[iIndex];
                    return el && el.checked;
                });

                if (checked) {
                    checked.el.dispatchEvent(new Event("change", { bubbles: true }));
                } else {
                    current.dispatchEvent(new Event("change", { bubbles: true }));
                }

                radioProcessed.add(name);
            } else {
                current.dispatchEvent(new Event("change", { bubbles: true }));
            }
        });
    });
};
